module.exports = __webpack_public_path__ + "img/3.c6a422e5.png";